module.exports = "tr td:last-child{vertical-align:middle}.editButton{cursor:pointer;vertical-align:text-bottom}"